














import * as Routes from '../routes';
import { Component, Prop, Vue } from 'vue-property-decorator';
import JoinButton from '@/browser/atoms/JoinButton.vue';
import Room from '@/models/Room';
import RoomInfoList from '@/browser/moleculers/RoomInfoList.vue';

@Component({
  components: {
    RoomInfoList,
    JoinButton,
  },
})
export default class RoomListItem extends Vue {
  @Prop({ required: true }) private room!: Room;

  private join(): void {
    this.$router.push({ name: Routes.Room.name, params: { roomId: this.room.id } });
  }
}
